


















































































































































































































































import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import {
  required,
  requiredIf,
  minLength,
  maxLength
} from 'vuelidate/lib/validators'
import { Component, Vue, Watch } from 'vue-property-decorator'
import Button from '@/app/ui/components/Button/index.vue'
import TextInput from '@/app/ui/components/TextInput/index.vue'
import DropdownSelect from '@/app/ui/components/DropdownSelect/index.vue'
import CustomTextInput from '../create/CustomTextInput/index.vue'
import controller from '@/app/ui/controllers/ManageCourierController'
import {
  EventBus,
  EventBusConstants,
  Utils
} from '@/app/infrastructures/misc'
import Modal from '@/app/ui/components/Modal/index.vue'
import WarningIcon from "@/app/ui/assets/warning_icon_modal.vue";
import { ManageCourierDetail, Partner } from '@/domain/entities/ManageCourier'
import SuccessIcon from "@/app/ui/assets/success_icon_modal.vue";
import router from '@/app/ui/router'
import {
  EnumOption,
  EnumOptions,
  EnumTypeCourier,
  EnumTypeVehicle,
  IFormTypeEdit,
  IHasChangedType,
  IParams
} from '@/app/infrastructures/misc/Constants/manageCourier'

@Component({
  mixins: [validationMixin],
  components: {
    Button,
    DropdownSelect,
    TextInput,
    CustomTextInput,
    Modal,
    WarningIcon,
    SuccessIcon
  },
})
export default class EditCourier extends Vue  {
  controller = controller
  successModal = false
  confirmationModal = false
  created(): void {
    controller.getCourierDetail(({ id: this.$route.params.id}))
  }
  beforeDestroy(): void {
    EventBus.$off(EventBusConstants.ADD_COURIER_SUCCESS)
  }
  get courierDetail(): ManageCourierDetail {
    return controller.manageCourierDetail
  }
  get bankAccountNameErrorMessage(): string {
    if (!this.form.bankAccountName) {
      return 'Bank Account Name is required'
    } else if (!this.isCharactersAllowed(this.form.bankAccountName)) {
      return 'Nama penerima hanya diperbolehkan spasi, alfanumerik, karakter "." dan ","'
    }
    return 'Bank Account Name must be between 3 - 30 characters'
  }
  form: IFormTypeEdit = {
    driverName: "",
    phoneNumber: "",
    courierType: [] as unknown as EnumOption ,
    announcementCourierType: [] as unknown as EnumOption,
    courierStatus: [] as unknown as EnumOption,
    vehicleType: [] as unknown as EnumOption,
    vehiclePlate: "",
    partnerName: [] as unknown as EnumOption,
    bankAccountName: "",
    bankName: [] as unknown as EnumOption,
    bankAccount: "",
  }
  hasChanged: IHasChangedType = {
    driverName: false,
    phoneNumber: false,
    courierType: false,
    announcementCourierType: false,
    courierStatus: false,
    vehicleType: false,
    vehiclePlate: false,
    partnerName: false,
    bankAccountName: false,
    bankName: false,
    bankAccount: false,
  }
  parameters: IParams = {
    search: '',
    agentType: this.form.courierType
  }
    courierType: EnumOptions = [
        {label: "KVP", value: "KVP"},
        {label: "POS", value: "POS"},
        {label: "Truck", value: "TRUCK"},
    ]
    vehicleType: EnumOptions  = [
        {label: "Motorcycle", value: "MOTORCYCLE"},
        {label: "Truck", value: "TRUCK"}

    ]
    statusType: EnumOptions  = [
        {label: "Active", value: "ACTIVE"},
        {label: "Banned", value: "BANNED"}
    ]
    bankList: EnumOptions  = [
        {label: "BCA", value: "BCA"},
        {label: "Mandiri", value: "MANDIRI"},
        {label: "Maybank", value: "MAYBANK"},
        {label: "BRI", value: "BRI"},
    ]
    partnerList: EnumOptions = []

  get params(): Record<string, string> {
    return {
      search: this.parameters.search.toUpperCase(),
      agent_type: this.form.courierType.value
    }
  }

  private fetchPartnersData(): void {
    if (this.params.search && this.params.agent_type) {
      controller.getAllPartner(this.params)
    }
  }

  private onSearchPartnerName = Utils.debounce((e: string) => {
    this.parameters.search = e
    this.fetchPartnersData()
  }, 400)

  @Validations()
  validations(): Record<string, unknown> {
    return {
      form: {
        driverName: { required },
        phoneNumber: { required },
        courierType: { required },
        announcementCourierType: { required },
        courierStatus: { required },
        vehicleType: { required },
        vehiclePlate: { required },
        partnerName: { required },
        bankAccountName: {
          required: requiredIf(() => {
            if (this.form.courierType.value) {
              return this.form.courierType.value.toUpperCase() !== EnumTypeCourier.TRUCK
            }
            return false
          }),
          minLength: minLength(3),
          maxLength: maxLength(30),
          isCharactersAllowed(value: string): boolean {
            return this.isCharactersAllowed(value)
          }
        },
        bankName: {required: requiredIf(() => {
          if (this.form.courierType.value) {
            return this.form.courierType.value.toUpperCase() !== EnumTypeCourier.TRUCK
          }
          return false
        })},
        bankAccount: {required: requiredIf(() => {
          if (this.form.courierType.value) {
            return this.form.courierType.value.toUpperCase() !== EnumTypeCourier.TRUCK
          }
          return false
        })}
      },
    }
  }

  @Watch("courierDetail")
  onCourierDetailChanged(val: ManageCourierDetail): void {
    this.form = {
      driverName: val.fullName,
      phoneNumber: val.phoneNumber.replace("+62", ""),
      courierType: this.courierType.find(
        (item) => item.value === val.courierType
      ) || [] as unknown as EnumOption,
      announcementCourierType: this.courierType.find(
        (item) => item.value === val.announcementCourierType
      ) || [] as unknown as EnumOption,
      courierStatus: this.statusType.find(
        (item) => item.value === val.status
      ) || [] as unknown as EnumOption,
      vehicleType: this.vehicleType.find(
        (item) => item.value === val.vehicleType
      ) || [] as unknown as EnumOption,
      vehiclePlate: val.vehiclePlate,
      partnerName: this.partnerList[-1],
      bankAccountName: val.bankInformation.bankAccountName,
      bankName: this.bankList.find(
        (item) => item.value === val.bankInformation.bankId
      ) || [] as unknown as EnumOption,
      bankAccount: val.bankInformation.bankAccount
    }

    this.parameters.search = val.partnerName.substring(
      val.partnerName.indexOf('[') + 1,
      val.partnerName.indexOf(']')
    )
    this.parameters.agentType = this.form.courierType

    this.fetchPartnersData()
  }

  @Watch('controller.partnerData')
  setPartnerData(data: Partner[]): void {
    const res = data.map((item) => {
      return {
        label: `${item.name} [${item.agentCode}]`,
        value: `${item.name} [${item.agentCode}]`
      }
    })

    this.partnerList = res

    if (!this.form.partnerName) {
      this.form.partnerName = this.partnerList[0]
    }
  }

  get isVehicleTypeTruck(): boolean {
    if (this.form.vehicleType.value) {
      return (this.form.vehicleType.value as string).toUpperCase() === EnumTypeVehicle.TRUCK
    }
    return false
  }

  private onEditCourier(): void {
    this.confirmationModal = false
    if (!this.$v.form.$invalid) {
      this.controller.updateCourier({
        courierId: this.$route.params.id,
        fullname: this.form.driverName,
        phoneNumber: "+62" + this.form.phoneNumber,
        courierType: this.form.courierType.value,
        courierStatus: this.form.courierStatus.value,
        vehicleType: this.form.vehicleType.value,
        vehiclePlate: this.form.vehiclePlate,
        partnerName: this.form.partnerName.value,
        bankAccountName: this.form.bankAccountName,
        bankId: this.form.bankName.value,
        bankAccount: this.form.bankAccount,
        announcementCourierType: this.form.announcementCourierType.value
      })
    } else {
      Vue.notify({
        title: 'Add Courier Invalid',
        text: 'Please check every invalid form',
        type: 'error',
        duration: 5000,
      })
    }

    this.hasChanged = {
        driverName: true,
        phoneNumber: true,
        courierType: true,
        courierStatus: true,
        announcementCourierType: true,
        vehicleType: true,
        vehiclePlate: true,
        partnerName: true,
        bankAccountName: true,
        bankName: true,
        bankAccount: true,
    }
  }

  get successModalEdit(): boolean {
    return controller.modalSuccessEdit;
  }

  private setSuccessModal(): void {
    router.push('/manage-user-&-courier/manage-courier')
    controller.setModalSuccessEdit(false)
  }

  private isCharactersAllowed(str: string): boolean {
    // this regex below will check character other than the allowed character
    // input only allow space, alphanumeric, comma (,) and period (.)
    const regex = /([^a-zA-Z0-9., ])+/g

    // return is negated for vuelidate
    return !regex.test(str)
  }
}
